import { APILoader } from '@api/client';
import { AuthenticationWrapper } from '@components/AuthenticationWrapper';
import { AuthProvider } from '@contexts/AuthProvider';
import HeroWrapperPage from '@pages/HeroWrapperPage';
import NotFoundPage from '@pages/NotFoundPage';
import OAuthPage from '@pages/OAuthPage';
import RegisterPage from '@pages/RegisterPage';
import AuthMethods from '@pages/RegisterPage/views/AuthMethods';
import { CompleteDataAfterRegistration, CompleteDataDuringRegistration } from '@pages/RegisterPage/views/CompleteData';
import RedeemCode from '@pages/RegisterPage/views/RedeemCode';
import RegistrationCode from '@pages/RegisterPage/views/RegistrationCode';
import RegistrationSuccess from '@pages/RegisterPage/views/RegistrationSuccess';
import { ResumeRedeemCode } from '@pages/RegisterPage/views/ResumeRedeemCode';
import { createBrowserRouter, Outlet } from 'react-router';

const router = createBrowserRouter([
  {
    element: (
      <AuthProvider>
        <APILoader>
          <HeroWrapperPage>
            <Outlet />
          </HeroWrapperPage>
        </APILoader>
      </AuthProvider>
    ),
    children: [
      { path: '*', Component: NotFoundPage },
      { path: 'oauth', Component: OAuthPage },
      {
        path: '/',
        Component: RegisterPage,
        children: [
          { index: true, Component: RegistrationCode },
          { path: 'auth', Component: AuthMethods },
          { path: 'redeem', Component: RedeemCode },
          { Component: AuthenticationWrapper, children: [{ path: 'redeem/resume', Component: ResumeRedeemCode }] },
          { path: 'complete', Component: CompleteDataDuringRegistration },
          { path: 'complete/resume', Component: CompleteDataAfterRegistration },
          { path: 'success', Component: RegistrationSuccess },
        ],
      },
    ],
  },
]);

export default router;
